import { createStore } from 'vuex'
import compras from './compras';
import auth from './auth';
import general from './general';
import congregacoes from './congregacoes';
import formatModule from './modules/formatModule';

export default createStore({
    modules: {
        compras,
        auth,
        general,
        congregacoes,
        format: formatModule,
    },
})